import React, { useState } from "react";
import { Button, Container, Logo, Menu, MenuItem, MobileButton, MobileButtonCTA, MobileMenu, MobileMenuItem, Wrapper } from "./styles";
import { Menu as MenuIcon, X } from "lucide-react";

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <Container>
            <Wrapper>
                <Logo href="#">
                    Nanocode
                </Logo>

                <Menu>
                    <MenuItem href="#services">
                        Servicios
                    </MenuItem>

                    <MenuItem href="#projects">
                        Proyectos
                    </MenuItem>

                    <MenuItem href="#contact">
                        Contacto
                    </MenuItem>
                </Menu>

                <Button>
                    Agenda una llamada
                </Button>

                <MobileButton onClick={() => setIsOpen(!isOpen)}>
                    {isOpen ? <X size={24} color="#fff"/> : <MenuIcon size={24} color="#fff"/>}
                </MobileButton>
            </Wrapper>

            {isOpen && (
                <MobileMenu>
                    <MobileMenuItem
                        href="#services"
                        onClick={() => setIsOpen(false)}
                    >
                        Servicios
                    </MobileMenuItem>

                    <MobileMenuItem
                        href="#projects"
                        onClick={() => setIsOpen(false)}
                    >
                        Proyectos
                    </MobileMenuItem>

                    <MobileMenuItem
                        href="#contact"
                        onClick={() => setIsOpen(false)}
                    >
                        Contacto
                    </MobileMenuItem>

                    <MobileButtonCTA
                        href="https://wa.me/5213316710897/?text=Hola,%20me%20interesa%20conocer%20los%20servicios%20de%20NanoCode%20y%20me%20gustar%C3%ADa%20cotizar%20una%20soluci%C3%B3n%20para%20mi%20negocio.%20%C2%BFPodr%C3%ADan%20brindarme%20m%C3%A1s%20informaci%C3%B3n%3F"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Agenda una llamada
                    </MobileButtonCTA>
                </MobileMenu>
            )}
        </Container>
    )
};

export default Navbar;